
import { LogEntry } from '@/api/dtos/LogEntry.schema'
import { eventTypeToGerman, logEntryToGerman } from '@/misc/i18n'
import moment from 'moment'
import { Component, Prop, Vue } from 'vue-property-decorator'
import CancelButton from '../buttons/CancelButton.vue'
import DangerButton from '../buttons/DangerButton.vue'
import EditFrame from '../EditFrame.vue'

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton
  }
})
export default class LogList extends Vue {
  @Prop()
  width!: string | number

  @Prop()
  height!: string | number

  @Prop()
  logEntries!: LogEntry[]

  eventTypeToGerman = eventTypeToGerman
  logEntryToGerman = logEntryToGerman
  moment = moment

  onLogEntryClicked (logEntry: LogEntry): void {
    this.$emit('entryClicked', logEntry)
  }

  logEntryToKV (logEntry: LogEntry): {
    [key: string]: string
  } {
    const out = {} as any
    switch (logEntry.category) {
      case 'ADMIN_CONFIG':
        out.Benutzer = logEntry.payload.user
        break
      case 'BOOKING':
        out.Station = logEntry.payload.stationName
        break
      case 'BOX_CONFIG':
        out.Station = logEntry.payload.stationName
        out.Box = logEntry.payload.device
        break
      case 'BOX_OPENING':
        out.Station = logEntry.payload.stationName
        out.Box = logEntry.payload.device
        break
      case 'CONTROLLER':
        out.Station = logEntry.payload.stationName
        break
      case 'OPERATOR_CONFIG':
        out.Betreiber = logEntry.payload.operatorName
        break
      case 'STATION_CONFIG':
        out.Station = logEntry.payload.stationName
        break
      case 'UPDATE':
        out.Station = logEntry.payload.stationName
        break
      case 'USER_CONFIG':
        out.Benutzer = logEntry.payload.user
        break
      default:
        return out
    }
    return out
  }

  getBorderColor (logEntry: LogEntry): string {
    switch (logEntry.severity) {
      case 'INFO':
        return this.$vuetify.theme.currentTheme.bpbInfo as string
      case 'WARNING':
        return this.$vuetify.theme.currentTheme.bpbWarn as string
      case 'ALARM':
        return this.$vuetify.theme.currentTheme.bpbDanger as string
    }
  }
}
